import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; 
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";

function SaleReport({branchID}) {

     const [noteType, setNoteType] = useState(null);
  const [fetchData, setfetchData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [branchDetail, setBranchDetail] = useState([])

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };


  const reportOptions = [
    
    { value: 'pending_quotation', label: 'Pending Quotation' },
      { value: 'purchase_pending_quotation', label: 'Pending Purchase Enquiry' },
  { value: 'pending_document', label: 'Pending Document' },
   { value: 'sale_order_list', label: 'Sale Order List' },
   { value: 'price_list', label: 'Price List' },
   { value: 'price_list_pkg', label: 'Price List (Pkg)' },
  ]



const handleSearch = async (e) => {
  e.preventDefault();

  const isPriceList = noteType?.value === 'price_list';

 
  if (!isPriceList && (!fromDate || !toDate)) {
    setToast('Please select both From Date and To Date', 'warning');
    return;
  }

  try {
    const params = {
      noteType: noteType?.value,
      from_date:fromDate,
      to_date:toDate
    };

    if (!isPriceList) {
      params.from_date = fromDate;
      params.to_date = toDate;
    }

    const result = await axios.get(
      'https://api.skyguard.group/api/get-sale-report',
      { params }
    );

    const resultData = result?.data?.result || [];
    //  console.log('list',resultData);
    setfetchData(resultData);

    // ✅ Separate success messages
    if (isPriceList) {
      if (resultData.length > 0) {
        setToast('Price List report fetched successfully', 'success');
      } else {
        setToast('No price list found', 'warning');
      }
      return;
    }

    if (resultData.length > 0) {
      setToast('Report fetched successfully', 'success');
    } else {
      setToast('No data found in selected date range', 'warning');
    }

  } catch (error) {
    console.error('❌ Error fetching report:', error);
    setToast('Error fetching report. Please try again.', 'danger');
  }
};


  const formatDateTime = (datetime) => {
    if (!datetime) return "";
    const [date, time] = datetime.split(" ");
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year} ${time}`;
  };

    const handleExportExcel = () => {
      const table = document.getElementById("exportTable");
    
      if (!table) return;
    
      const worksheet = XLSX.utils.table_to_sheet(table);
      const workbook = XLSX.utils.book_new();
    
      XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");
    
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
    
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
    
      saveAs(data, "Sale_Report.xlsx");
    };

  return (
 
        <>

      <div className='main-section'>
        <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

          <h3 className='my-3 fw-bold fs-5 golos'>Report</h3>


          <div className="row g-3 align-items-end">
            <div className="col-md-4">
              <label className='fw-bold'>Select Report</label>
              <Select
                options={reportOptions}
                placeholder="Choose Type ..."
                id="source"
                value={noteType}

                onChange={(selected) => {
                  setNoteType(selected);
                  setfetchData([]);
                }}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>From Date</label>
              <input
                type="date"
                className="form-control"
                name="from_date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-4">
              <label className='fw-bold'>To Date</label>
              <input
                type="date"
                className="form-control"
                name="to_date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>


            <div className="col-md-12 d-flex justify-content-end align-items-end">
              {/* <button className="btn btn-primary" onClick={handleSearch} >Search</button> */}
               <FaSearch size={26} className="ms-1 text-primary"
                              style={{ cursor: "pointer" }}
                              title="Search"
                              onClick={handleSearch}
                            />
              
                            <MdLocalPrintshop
                              size={26}
                              className="ms-1 text-success"
                                 onClick={handleExportExcel}
                              style={{ cursor: "pointer" }}
                              title="Print "
                            />
            </div>
          </div>

          <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            {noteType?.value === 'price_list' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Raw Material</th>
                    <th>Category</th>
                    <th>UOM</th>
                    <th>MRP</th>
                      <th>Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.name}</td>
                        <td>{item.category}</td>
                        <td>{item.uom}</td>
                        <td>{item.mrp} </td>
                        <td> {item.rate} </td>
                      
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">No data found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}

            {noteType?.value === 'pending_quotation' && (
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                    <th>Doc No</th>
                    <th>Date</th>
                    <th> Party</th>

                    <th>Item</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.flatMap((row, rowIdx) => {


                      let itemsArr = [];
                      try {
                        itemsArr = typeof row.items === 'string'
                          ? JSON.parse(row.items)
                          : row.items || [];
                      } catch {
                        itemsArr = [];
                      }

                      const visitsArr = Array.isArray(row.visits) ? row.visits : [];


                      if (visitsArr.length === 0) {
                        return itemsArr.map((it, itIdx) => {
                          const srNo = Array.isArray(it.sr_no) ? it.sr_no.join(', ') : '-';

                          return (
                            <tr key={`${rowIdx}-${itIdx}-novisit`}>

                              <td>{`SQ/${row.inv_no}/${row.branchId}`}  </td>
                              <td> {row.quotation_date} </td>
                              <td>{row.party_name}</td>
                              <td>{it.name}</td>
                            </tr>
                          );
                        });
                      }

                      return itemsArr.flatMap((it, itIdx) => {
                        const srNo = Array.isArray(it.sr_no) ? it.sr_no.join(', ') : '-';

                        return visitsArr.map((v, vIdx) => {
                          const visitDate = v.visitDate
                            ? new Date(v.visitDate).toLocaleString()
                            : '-';

                          return (
                            <tr key={`${rowIdx}-${itIdx}-${vIdx}`}>
                              <td>{row.party_name}</td>
                              <td>{it.name}</td>
                              <td>{srNo}</td>
                              <td>{visitDate}</td>
                            </tr>
                          );
                        });
                      });
                    })
                  ) : (
                    <tr>
                      <td colSpan="4">No data found</td>
                    </tr>
                  )}

                </tbody>
              </table>
            )}

              {noteType?.value === 'purchase_pending_quotation' && (
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                    <th>Doc No</th>
                    <th>Date</th>
                    <th> Party</th>

                    <th>Item</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(fetchData) && fetchData.length > 0 ? (
                    fetchData.flatMap((row, rowIdx) => {


                      let itemsArr = [];
                      try {
                        itemsArr = typeof row.items === 'string'
                          ? JSON.parse(row.items)
                          : row.items || [];
                      } catch {
                        itemsArr = [];
                      }

                      const visitsArr = Array.isArray(row.visits) ? row.visits : [];


                      if (visitsArr.length === 0) {
                        return itemsArr.map((it, itIdx) => {
                          const srNo = Array.isArray(it.sr_no) ? it.sr_no.join(', ') : '-';

                          return (
                            <tr key={`${rowIdx}-${itIdx}-novisit`}>

                              <td>{`PE/${row.inv_no}/${row.branchId}`}  </td>
                              <td> {row.date} </td>
                              <td>{row.party_name}</td>
                              <td>{it.name}</td>
                            </tr>
                          );
                        });
                      }

                      return itemsArr.flatMap((it, itIdx) => {
                        const srNo = Array.isArray(it.sr_no) ? it.sr_no.join(', ') : '-';

                        return visitsArr.map((v, vIdx) => {
                          const visitDate = v.visitDate
                            ? new Date(v.visitDate).toLocaleString()
                            : '-';

                          return (
                            <tr key={`${rowIdx}-${itIdx}-${vIdx}`}>
                              <td>{row.party_name}</td>
                              <td>{it.name}</td>
                              <td>{srNo}</td>
                              <td>{visitDate}</td>
                            </tr>
                          );
                        });
                      });
                    })
                  ) : (
                    <tr>
                      <td colSpan="4">No data found</td>
                    </tr>
                  )}

                </tbody>
              </table>
            )}


  {noteType?.value === 'pending_document' && (
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                    <th>Doc No</th>
                    <th>Date</th>
                    <th> Party</th>
                    <th>Document Type</th>
                  </tr>
                </thead>
                <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((row, rowIdx) => {

      let docPrefix = '';

      switch (row.type_acc) {
        case 'sale_invoice':
          docPrefix = 'SL';
          break;

        case 'Purchase':
          docPrefix = 'PU';
          break;

        case 'amc':
          docPrefix = 'AMC';
          break;

        case 'repair_invoice':
          docPrefix = 'RI';
          break;

        default:
          docPrefix = 'DOC';
      }

      return (
        <tr key={rowIdx}>
          
          <td>
            {docPrefix}/{row.inv_no || row.id}/{row.branchId}
          </td>

          <td>
            {new Date(row.payment_date).toLocaleDateString()}
          </td>

          <td>
            {row.party_name}
          </td>

          <td>
            {row.type_acc}
          </td>

        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="4">No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}

  {noteType?.value === 'sale_order_list' && (
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                      
                    <th>Oder ID</th>
                    <th>Customer Name</th>
                    <th>Contact</th>
                    <th>Address</th>
                    <th>Order Date</th>
                    <th>Order Status </th>
                        <th>Amount </th>
                  </tr>
                </thead>
                <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((row, rowIdx) => {

    

      return (
        <tr key={rowIdx}>
          
          <td>
         {row.id}
          </td>
          <td> {row.party_name} </td>

          <td>{row.cust_contact} </td>
          <td> {row.cust_address} </td>

          <td>
            {new Date(row.order_date).toLocaleDateString()}
          </td>

          <td>
            {row.order_status}
          </td>

        
          <td>
          {row.order_total}
          </td>

        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="4">No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}


  {noteType?.value === 'price_list_pkg' && (
              <table className="table table-bordered table-striped table-hover text-center align-middle">
                <thead className='table-info'>
                  <tr>
                      
      <th>Item Name</th>
      <th>Unit</th>
      <th>MRP</th>
       <th>Vendor Price</th>
       <th>Retailer Price</th>
      <th>GST</th>
      <th>Stock</th>
                  </tr>
                </thead>
                <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((row, rowIdx) => {
      return (
        <tr key={rowIdx}>
   
        <td>{row.name}</td>
        <td>{row.uom}</td>
        <td>{row.mrp}</td>
       <td>{row.vendor_price} </td>
        <td>{row.retailer_price} </td>
            <td>{row.tax}</td>
        <td>{row.stock}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="4">No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}

          </div>


        </div>
      </div>
    </>
  )
}

export default SaleReport